module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_4_sub2-20feaf1eabb4224f69b246c019939e1e.png";